import React, { useEffect } from 'react';
export function Envios() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="legal-page" data-id="element-234" data-mp="43eqjcxh58av">
      <div className="legal-hero" data-id="element-235" data-mp="42dbyyh923oe">
        <p className="legal-overline" data-id="element-236" data-mp="izm6g11unnkc">Información importante</p>
        <h1 className="legal-title" data-id="element-237" data-mp="iz4cjb2ntlfl">Envíos & Devoluciones</h1>
        <p className="legal-subtitle" data-id="element-238" data-mp="e0j972s42lmx">
          Cada vela SAVIA es hecha a mano y bajo pedido. Leé esto antes de
          comprar — es breve y claro.
        </p>
      </div>
      <div className="legal-body" data-id="element-239" data-mp="3hhrtdtab9xkt">
        {/* SECCIÓN 1: PRODUCCIÓN */}
        <div className="legal-section" data-id="element-240" data-mp="3hff3mtybaix7">
          <h2 data-id="element-241" data-mp="19wid3469np">Producción bajo pedido</h2>
          <p data-id="element-242" data-mp="2clgfgvm20z">
            Todas las velas SAVIA son elaboradas artesanalmente después de
            recibir tu pedido. No manejamos stock permanente — cada pieza se
            hace especialmente para ti.
          </p>
          <p data-id="element-243" data-mp="33ns4mmcziwaq">
            <strong data-id="element-244" data-mp="2yra1ts17t811">Tiempo de producción:</strong> 2 a 4 días hábiles desde la
            confirmación del pago.
          </p>
          <p data-id="element-245" data-mp="1txagkk9nlp5a">
            <strong data-id="element-246" data-mp="1tvplmtjfg46w">Tiempo de entrega:</strong> Bogotá: 1–2 días hábiles
            adicionales. Resto de Colombia: 3–7 días hábiles según destino.
          </p>
        </div>
        {/* SECCIÓN 2: ENVÍOS */}
        <div className="legal-section" data-id="element-247" data-mp="22pcg8gbwf1ei">
          <h2 data-id="element-248" data-mp="27nw1eeio495t">Envíos</h2>
          <p data-id="element-249" data-mp="27o5i1bhtp3yu">
            Enviamos a todo el territorio nacional colombiano a través de
            operadores logísticos certificados. Tu pedido llega protegido con
            nuestro sistema de empaque honeycomb — diseñado para viaje seguro.
          </p>
          <ul data-id="element-250" data-mp="1f11ktsoz1txm">
            <li data-id="element-251" data-mp="1jyb7j0kz7rhr">Bogotá: envío estándar disponible</li>
            <li data-id="element-252" data-mp="1jwqc78qu84iu">Medellín, Cali, Barranquilla: 3–5 días hábiles</li>
            <li data-id="element-253" data-mp="1oxo4ie5kaey2">Demás municipios: 5–7 días hábiles</li>
            <li data-id="element-254" data-mp="1ovbdlbhtsu8v">Zonas de difícil acceso: consultar disponibilidad</li>
          </ul>
          <p data-id="element-255" data-mp="2vd8919yck960">
            El costo de envío se calcula al momento del checkout según tu
            ubicación y el peso del pedido.
          </p>
        </div>
        {/* SECCIÓN 3: SEGUIMIENTO */}
        <div className="legal-section" data-id="element-256" data-mp="2amkt3c8c5vnk">
          <h2 data-id="element-257" data-mp="25pkybxgxsfbr">Seguimiento de tu pedido</h2>
          <p data-id="element-258" data-mp="25ojbkvqk64e7">
            Una vez despachado tu pedido recibirás el número de guía por
            WhatsApp o correo electrónico para hacer seguimiento en tiempo real.
          </p>
          <p data-id="element-259" data-mp="2fn8r4huzfcra">
            Si tienes dudas sobre el estado de tu envío, escríbenos directamente
            al <a href="https://wa.me/573213396782" data-id="element-260" data-mp="1rx4oodtj5j1v">WhatsApp</a>.
          </p>
        </div>
        {/* SECCIÓN 4: POLÍTICA DE DEVOLUCIONES */}
        <div className="legal-section legal-section--highlight" data-id="element-261" data-mp="1mwqhexzr6d4w">
          <h2 data-id="element-262" data-mp="21osmcwgojwbs">Política de devoluciones y cambios</h2>
          <p data-id="element-263" data-mp="1wx0wko5clump">
            Por la naturaleza artesanal y personalizada de nuestros productos,{' '}
            <strong data-id="element-264" data-mp="197gbnzpmwnas">SAVIA no acepta devoluciones por cambio de opinión.</strong>{' '}
            Te pedimos que leas con cuidado las notas olfativas de cada vela
            antes de comprar.
          </p>
          <h3 data-id="element-265" data-mp="3fvp2xl62cl6v">¿Cuándo sí aplica una solución?</h3>
          <p data-id="element-266" data-mp="3fux84ckairhn">
            Aceptamos solicitudes de cambio o reembolso únicamente en los
            siguientes casos:
          </p>
          <ul data-id="element-267" data-mp="3ko8fcet0laa3">
            <li data-id="element-268" data-mp="35xixwuoymyxs">
              <strong data-id="element-269" data-mp="35y14ak5c6tjf">Producto dañado en el envío:</strong> Debes notificarnos
              dentro de las primeras <strong data-id="element-270" data-mp="3aw2l0yfaigrq">24 horas</strong> de recibir el
              paquete, con fotografías del empaque y el producto.
            </li>
            <li data-id="element-271" data-mp="2hbw6tq3vbrn">
              <strong data-id="element-272" data-mp="2epp0v74my9y">Producto incorrecto:</strong> Si recibiste una vela
              diferente a la que pediste, la reemplazamos sin costo adicional.
            </li>
            <li data-id="element-273" data-mp="3pkqf109hmifk">
              <strong data-id="element-274" data-mp="3pl8m6rxouh29">Defecto de fabricación:</strong> Imperfecciones menores
              son características del proceso artesanal y no constituyen
              defecto. Solo aplica para fallas que impidan el uso normal del
              producto.
            </li>
          </ul>
          <h3 data-id="element-275" data-mp="2i8pzmrkv8f00">¿Cómo solicitar una solución?</h3>
          <ol data-id="element-276" data-mp="2yf2xxi3ihk0w">
            <li data-id="element-277" data-mp="2yfl4b7jw1emj">Escríbenos al WhatsApp dentro del plazo indicado</li>
            <li data-id="element-278" data-mp="2ygw7p69f8kd4">Envía fotos del producto y del empaque</li>
            <li data-id="element-279" data-mp="2tnkxqw9bbngz">Te respondemos en máximo 48 horas hábiles</li>
            <li data-id="element-280" data-mp="2op08frvlmo7b">Coordinamos la solución más adecuada</li>
          </ol>
          <p className="legal-note" data-id="element-281" data-mp="2on71ebh2q1ys">
            <strong data-id="element-282" data-mp="2jqoxfdtki7ni">Nota importante:</strong> Las variaciones sutiles en color,
            textura y aroma entre lotes son inherentes al proceso artesanal y no
            constituyen defecto. Cada vela es única.
          </p>
        </div>
        {/* SECCIÓN 5: PAGOS */}
        <div className="legal-section" data-id="element-283" data-mp="3cd1durxhdoii">
          <h2 data-id="element-284" data-mp="37ezqvvwxp51r">Medios de pago</h2>
          <ul data-id="element-285" data-mp="37dy6h0u1367d">
            <li data-id="element-286" data-mp="37hm0e13dxumm">MercadoPago (tarjetas crédito y débito)</li>
            <li data-id="element-287" data-mp="33de8jv1mryk6">PSE — transferencia bancaria</li>
            <li data-id="element-288" data-mp="1w0m998srxlu6">
              Contraentrega disponible en Bogotá (consultar disponibilidad)
            </li>
          </ul>
          <p data-id="element-289" data-mp="1ryhhkflvyza6">
            Todos los pagos en línea son procesados de forma segura. SAVIA no
            almacena datos de tarjetas.
          </p>
        </div>
      </div>
    </div>;
}